import { DEFAULT_THEME } from '../constants';

const appProps = (state = {
    activeUserDetailed: null,
    userDetailedType: 'panel',
    userDetailedTab: undefined,
    userDetailedExtraData: null,
    theme: null,
    passedTours: [],
    skippedHelp: [],
    progress: 0,
    changingTeam: false,
    socketError: false,
    currentProject: null
}, action) => {
    switch (action.type) {
        case 'AUTH_DETAILS_SET_REQUESTED':
            if (!action.payload.masterToken) {
                return Object.assign({}, state, {
                    theme: null
                });
            }

            return state;

        case 'APP_PROPS_FETCH_SUCCEEDED':
            if (!action.payload.props) {
                return state;
            }

            return Object.assign({}, state, action.payload.props);

        case 'CURRENT_USER_FETCH_SUCCEEDED':
            if (!action.payload || !action.payload.user) {
                return state;
            }

            return Object.assign({}, state, {
                theme: (action.payload?.user?.theme) || null,
                passedTours: action.payload.user.passed_tours || [],
                skippedHelp: action.payload.user.skipped_help || []
            });

        case 'CURRENT_USER_UPDATE_REQUESTED':
            return Object.assign({}, state, {
                theme: action.payload.userProps.theme || state.theme,
                passedTours: action.payload.userProps.tour_passed ? [...(state.passedTours || []), action.payload.userProps.tour_passed] : state.passedTours,
                skippedHelp: action.payload.userProps.help_skipped ? [...(state.skippedHelp || []), action.payload.userProps.help_skipped] : state.skippedHelp
            });

        case 'SET_THEME':
            return Object.assign({}, state, {
                theme: action.payload.theme
            });

        case 'USER_DETAILED_ACTIVATE_REQUESTED':
            return Object.assign({}, state, {
                activeUserDetailed: action.payload.userId,
                userDetailedType: action.payload.type || state.userDetailedType,
                userDetailedTab: action.payload.tab || state.userDetailedTab,
                userDetailedExtraData: action.payload.extraData
            });

        case 'USER_DETAILED_DEACTIVATE_REQUESTED':
            return Object.assign({}, state, {
                activeUserDetailed: null,
                userDetailedTab: undefined
            });

        case 'CREATE_PROJECT_TOGGLE':
            return Object.assign({}, state, {
                createProjectVisible: action.payload.visible
        });

        case 'SSO_REQUIRED_UPDATE':
            return Object.assign({}, state, {
                ssoRequired: action.payload
            });

        case 'SET_GLOBAL_PROGRESS':
            return Object.assign({}, state, {
                progress: action.payload.progress,
                progressTitle: action.payload.title
            });

        case 'BEFORE_TEAM_CHANGE':
            return Object.assign({}, state, {
                changingTeam: true
            });

        case 'TEAM_CHANGE':
            return Object.assign({}, state, {
                changingTeam: false
            });

        case 'SET_SOCKET_ERROR_STATE':
            return Object.assign({}, state, {
                socketError: action.payload.hasError
            });

        case 'SET_CURRENT_PROJECT':
            return Object.assign({}, state, {
                currentProject: action.payload.projectId
            });

        default:
            return state;
    }
}

export default appProps;
